import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '@/lib/api';
import type { Client } from '@/lib/types';

async function readError(res: Response): Promise<string> {
  const data = (await res.json().catch(() => null)) as { error?: string } | null;
  return data?.error ?? `Ошибка запроса (${res.status})`;
}

export function useClientsPage() {
  const [clients, setClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const clientsRes = await apiFetch('/api/v1/admin/clients');
      if (!clientsRes.ok) throw new Error(await readError(clientsRes));
      // worker_count приходит в элементах списка (GROUP BY по workers.client_id)
      setClients((await clientsRes.json()) as Client[]);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось загрузить клиентов');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchClients();
  }, [fetchClients]);

  return { clients, isLoading, error };
}
